import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "退職者名",
    keyword: "staffNo",
    type: "text",
  },
  {
    title: "勤務先",
    keyword: "facilityName",
    type: "text",
  },
  {
    title: "氏名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "被共済職員期間",
    keyword: "maePeriodDate",
    type: "text",
  },
  {
    title: `退職日`,
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "退職理由",
    keyword: "retireProcedureReason",
    type: "text",
  },
  {
    title: "郵便番号",
    keyword: "zipcode",
    type: "text",
  },
  {
    title: "住所",
    keyword: "address",
    type: "text",
  },
  {
    title: "電話番号",
    keyword: "tel",
    type: "text",
  },
  {
    title: "退職者メールアドレス（機構連絡用）",
    keyword: "email",
    type: "text",
  },
  {
    title: "代行者連絡先メールアドレス",
    keyword: "agentEmail",
    type: "text",
  },
  {
    title: "委任状",
    keyword: "powerOfAttorney",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
];

export { fakeTableList };
